<template>
  <div class="page-con">
    <div class="page-con-header clearfix" style="positon:relative;display:flex;">
      <template>
        <AutoComplete
            v-model="dict"
            :data="searchData"
            placeholder="请输入字典"
            clearable
            :filter-method="filterMethod"
            style="width:200px"></AutoComplete>
        <Button status="primary" style="margin-left: 10px;border-radius: 4px" @click="search">搜索</Button>
      </template>
      <div class="page-header-right">
        <vxe-button @click="$refs.xTree.setAllTreeExpand(true)">展开所有</vxe-button>
        <vxe-button @click="$refs.xTree.clearTreeExpand()">关闭所有</vxe-button>
        <vxe-button icon="vxe-icon--refresh" @click="search">刷新</vxe-button>
      </div>
    </div>

    <div class="list-box common-shadow clearfix">
      <vxe-table
          row-id="id"
          :tree-config="{transform: true, reserve: true,expandRowKeys: defaultExpandKeys}"
          highlight-hover-row
          highlight-current-row
          show-overflow
          ref="xTree"
          border="none"
          row-key
          align="center"
          class="sortable-row-demo"
          :scroll-y="{enabled: false}"
          @toggle-tree-expand="toggleTreeExpand"
          :data="dictList"
          :loading="loading"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column width="60">
          <template v-slot ={row}>
              <span class="drag-btn" v-if="row.dictCodeP == 0 && row.id === currentId">
               <img style="margin-right: 5px" src="@/assets/images/common/tz.png"/>
              </span>
          </template>
          <template v-slot:header>
            <vxe-tooltip v-model="showHelpTip1" content="按住后可以上下拖动排序！" enterable>
              <i class="vxe-icon--question" @click="showHelpTip1 = !showHelpTip1"></i>
            </vxe-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column field="id" title="序号"  min-width="100"></vxe-table-column>
        <vxe-table-column field="dictText" title="字典标题" align="left" min-width="300" tree-node>
          <template v-slot="{row}">
            <span :title="row.dictText" v-if="row.dictCodeP == 0"
                  style="display: inline-block;padding-top: 5px;width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; color: #2d8cf0">{{row.dictText}}</span>
            <span :title="row.dictText" v-else
                  style="display: inline-block;padding-top: 5px;width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{row.dictText}}</span>
          </template>

        </vxe-table-column>
        <vxe-table-column field="note" title="字典内容" min-width="100" align="left"></vxe-table-column>
        <vxe-table-column field="orderBy" title="字典排序" min-width="50">
          <template v-slot="{row}">
            <span v-if="row.dictCodeP !== 0">{{row.orderBy}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="remark" title="字典描述" min-width="100"></vxe-table-column>

        <vxe-table-column field="type" title="操作" min-width="200">
          <template v-slot="{row}">
            <div>
              <a style="color:#67C23A;" @click.stop="addSub(row)" v-if="row.isForCustom == 1 || row.dictCodeP !=0">添加</a>
              <a style="color:#409EFF;margin-left: 10px" @click.stop="update(row)">编辑</a>
              <a style="color:#F56C6C;margin-left: 10px" v-if="row.dictCodeP !== 0" @click.stop="remove(row)">删除</a>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal v-model="isShowMenuInfo" :title="modalTitle" @close="closeModal" height="500" width="500"
               destroy-on-close resize position="center">
      <create-dict-modal ref="dictModal" :isSystem="row!=null && row.isForCustom == 0" @afterSave="afterSave" @close="closeModal"></create-dict-modal>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import CreateDictModal from "./CreateDictModal";
import Sortable from 'sortablejs';
import CACHE_URL_KEY_NAME from "@/consts";
import {isNotEmpty} from "@/utils/util";
const assign = (val) => Object.assign({}, val);
export default {
  components: {CreateDictModal},
  data() {
    return {
      defaultExpandKeys: [],
      dict: '',
      dictList: [],
      isShowMenuInfo: false,
      showHelpTip1: false,
      modalTitle: "",
      loading: false,
      searchData: [],
      row: null,
      currentId:0,
    };
  },
  mounted() {
    this.$bus.$on("字典管理", () => {
      this.init();
      this.$refs.xTree.clearTreeExpand()
    });
    this.init();
    this.$refs.xTree.clearTreeExpand()
  },
  beforeDestroy () {
    if (this.sortable1) {
      this.sortable1.destroy()
    }
  },
  methods: {
    init() {
      this.getDictList();
      this.rowDrop();
    },
    rowDrop () {
      let keyStr = localStorage.getItem(CACHE_URL_KEY_NAME)
      let keyArr = keyStr.split(",")
      keyArr.forEach(item => {
        if (isNotEmpty(item)){
          localStorage.setItem(item,"")
        }
      })
      this.$nextTick(() => {
        const xTable = this.$refs.xTree
        this.sortable1 = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
          handle: '.drag-btn',
          onStart: function (/**Event*/evt) {
            let keyStr = localStorage.getItem(CACHE_URL_KEY_NAME)
            let keyArr = keyStr.split(",")
            keyArr.forEach(item => {
              if (isNotEmpty(item)){
                localStorage.setItem(item,"")
              }
            })
            console.log(evt);
          },
          onMove: function (/**Event*/evt, /**Event*/originalEvent) {
            // Example: https://jsbin.com/nawahef/edit?js,output
            console.log(evt,originalEvent);
          },
          onEnd: ({ newIndex, oldIndex }) => {
            var copyList = this.dictList.slice(0);
            var oldData = copyList[oldIndex];
            var newData = copyList[newIndex];

            const currRow = this.dictList.splice(oldIndex, 1)[0]

            this.dictList.splice(newIndex, 0, currRow)
            let preId = 0;
            if (newIndex-1>=0){
              preId = this.dictList[newIndex-1].id;
            }
            var obj = {
              curId:oldData.id,
              preId:preId
            }
            console.log(obj);
            if (oldIndex !== newIndex){

              this.sortDict(obj)
            }

          }
        })
      })
    },
    async sortDict(obj){
      this.loading = true;
      let res = await $api.dict.post("sortDict", obj);
      this.loading = false;
      if (res.status === 1) {
        this.loading = false;
        this.getDictList();
      }
    },

    filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    search() {
      if (this.dict === '') {
        this.getDictList();
      } else {
        this.searchDict();
      }
    },
    toggleTreeExpand({expanded, row}) {
      if (expanded) {
        this.defaultExpandKeys.push(row.id);
      } else {
        let key = this.defaultExpandKeys.indexOf(row);
        this.defaultExpandKeys.splice(key, 1)
      }
    },
    async searchDict() {
      this.loading = true;
      let res = await $api.dict.get("searchDic", {
        searchParentText: this.dict
      });
      this.loading = false;
      if (res.status === 1) {
        let dict = res.data;
        const groupBy = (arr, key) =>
            arr.reduce(
                (acc, item) => (
                    (acc[item[key]] = [...(acc[item[key]] || []), item]), acc
                ),
                {}
            );
        let obj = groupBy(dict, "dictCodeP");
        let root = [];

        dict.forEach((el) => {
          // 判断根节点
          if (el.dictCodeP === 0) {
            root.push(el);
            return;
          }
        });
        root = root.map((i) => {
          let arr = [];
          if (obj[i.dictCode] && obj[i.dictCode].length > 0) {
            arr = obj[i.dictCode];
          }
          arr.map((j) => {
            return Object.assign(j, { children: obj[j.dictCode] || [] });
          });
          return Object.assign(i, { children: arr });
        });

        this.dictList = root;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async getDictList() {
      let searchData = [];
      this.loading = true;
      let res = await $api.dict.get("getDicByParentCode/");
      this.loading = false;
      if (res.status === 1) {
        let dict = res.data;
        const groupBy = (arr, key) =>
            arr.reduce(
                (acc, item) => (
                    (acc[item[key]] = [...(acc[item[key]] || []), item]), acc
                ),
                {}
            );
        let obj = groupBy(dict, "dictCodeP");
        let root = [];

        dict.forEach((el) => {
          // 判断根节点
          if (el.dictCodeP === 0) {
            root.push(el);
            return;
          }
        });
        root = root.map((i) => {
          let arr = [];
          if (obj[i.dictCode] && obj[i.dictCode].length > 0) {
            arr = obj[i.dictCode];
          }
          arr.map((j) => {
            return Object.assign(j, { children: obj[j.dictCode] || [] });
          });
          return Object.assign(i, { children: arr });
        });

        this.dictList = root;
        this.$forceUpdate()
      } else {
        this.$XModal.message(res.message);
      }
    },
    afterSave() {
      this.isShowMenuInfo = false;
      this.search();
    },
    closeModal() {
      this.isShowMenuInfo = false;
      this.$refs.dictModal.reset();
    },
    addSub(row) {
      this.row = row;
      this.modalTitle = "新增字典";
      this.isShowMenuInfo = true;
      this.$nextTick(() => {
        this.$refs.dictModal.setDictCodeP(row);
      });
    },
    update(row) {
      this.row = row;
      this.modalTitle = "修改系统属性";
      this.isShowMenuInfo = true;
      this.$nextTick(() => {
        this.$refs.dictModal.setUpdate(row);
      });
    },
    async remove(row) {
      let keyStr = localStorage.getItem(CACHE_URL_KEY_NAME)
      let keyArr = keyStr.split(",")
      keyArr.forEach(item => {
        if (isNotEmpty(item)){
          localStorage.setItem(item,"")
        }
      })
      this.row = row;
      let confirmRes = await this.$XModal.confirm(
          "删除后不可恢复",
          "是否删除？"
      );
      if (confirmRes === "confirm") {
        let res = await $api.dict.post("addOrUpdateDic/", {
          id: row.id,
          isDelete: 1
        });
        if (res.status === 1) {
          this.$Message.success('删除成功');
          this.search();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      }
    },
    async submitEvent() {
      let row = this.formInfo;
      row.parentId = this.parentInfo.id;
      let res;
      if (row.id == 0) {
        if (this.menuTypes.includes(row.type)) {
          res = await $api.menu.post("add", row);
        } else {
          row.name = row.title
          row.menuId = row.parentId
          res = await $api.element.post("add", row);
        }
      } else {
        if (this.menuTypes.includes(row.type)) {
          res = await $api.menu.post("update/" + row.id, row);
        } else {
          row.name = row.title
          row.menuId = row.parentId
          res = await $api.element.post("update/" + row.id, row);
        }
      }
      this.$XModal.message(res.message);
      if (res.status == 1) {
        this.isShowMenuInfo = false;
        this.search();
      }
    },
    currentChangeEvent({ row }){
      this.currentId = row.id;
    },
    changeFile(imgUrl) {
      this.formInfo.icon = imgUrl;
    },
  }
  ,
}
;
</script>
<style lang="css">
.page-header-right {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
}
</style>